import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
    fetchRoutes,
    fetchRouteById,
    createRoute,
    updateRoute,
    deleteRoute
} from '../api/routesService';

export const useRoutes = () => {
    const queryClient = useQueryClient();

    const { data: routes, isLoading, error } = useQuery({
        queryKey: ['routes'],
        queryFn: fetchRoutes,
    });

    const createMutation = useMutation({
        mutationFn: createRoute,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['routes'] });
        },
    });

    const updateMutation = useMutation({
        mutationFn: ({ id, data }) => updateRoute(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['routes'] });
        },
    });

    const deleteMutation = useMutation({
        mutationFn: deleteRoute,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['routes'] });
        },
    });

    return {
        routes,
        isLoading,
        error,
        createMutation,
        updateMutation,
        deleteMutation,
    };
};

export const useFetchRouteById = (id, enabled = false) => {
    return useQuery({
        queryKey: ['routes', id],
        queryFn: () => fetchRouteById(id),
        enabled,
    });
};
